import React from 'react';
import styled from '@emotion/styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'

// import static icons
import CloseIcon from '/static/icons/controls/close.svg'

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 6px;
  border: 1px solid ${props => props.theme.colors.stroke};
  box-sizing: border-box;
  border-radius: ${props => props.theme.borderRadius.round};
  cursor: pointer;
  > .react-datepicker-wrapper {
    width: 100%;
    input {
      width: 100%;
      border: none;
      outline: none;
    }
  }
  svg {
    width: 16px;
    margin-right: 6px;
  }
`;
const ControlButton = props => {
  return (
    <Wrapper>
      {/* <label>{props.text}</label> */}
      {props.icon && <FontAwesomeIcon icon={props.icon} onClick={props.handleClick}/>}
      {props.children}
      <FontAwesomeIcon icon={faTimes} onClick={props.handleClose}/>
    </Wrapper>
  )
}

export default ControlButton;